









import SpotlightWaveDisplay from "~/themes/fiskarsMoominDefault/components/components/molecules/SpotlightWaveDisplay/SpotlightWaveDisplay.vue";
import {imagePlaceholderProduct} from "~/common";
import {computed} from "@nuxtjs/composition-api";

export default {
  name: "MoominSpotlightWaveDisplay",
  components: {SpotlightWaveDisplay},
  props: {
    image: {
      type: Object,
      default: {
        desktop: imagePlaceholderProduct,
        mobile: imagePlaceholderProduct,
        thumbnail: imagePlaceholderProduct,
        alt: "image",
      },
    },
    title: {
      type: String,
      default: "What are the Moomins?",
    },
    subtitle: {
      type: String,
      default: "We believe you don’t have to be a child to be young at heart to recognise a great story told in a beautiful way. The wonderful world of Moominvalley has been featured on Arabia products already since the 1950’s.",
    },
    color: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const _returnColor = computed(() => {
      return props.color?.color?.selectionValues ? props.color?.color?.selectionValues[0]?.key : 'var(--c-secondary-sand)';
    })

    return {
      _returnColor
    }
  }
}
